import { Elm } from "../Main.elm";

// La configuration d'exécution (config.json) est générée au build depuis l'environnement.
fetch("/config.json")
    .then((reponse) => reponse.json())
    .catch(() => null)
    .then((config) => Elm.Main.init({ flags: config }));
